import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { CALENDAR_DATE_RANGE_TYPE } from "features/planner/planner.constants";
import Deployment from "features/planner/employee/calendar/components/Deployment";
import WorkScheduleOverride from "features/planner/employee/calendar/components/WorkScheduleOverride";

const CalendarOverride = ({ count, item, employeeCardId }) => {
  return item.get("type") === CALENDAR_DATE_RANGE_TYPE.AVAILABILITY_OVERRIDE ? (
    <WorkScheduleOverride
      count={count}
      key={item.get("id")}
      availabilityOverride={item}
      employeeCardId={employeeCardId}
    />
  ) : (
    <Deployment count={count} key={item.get("id")} deploymentDetail={item} />
  );
};

const AvailabilityOverrides = ({ classes, dateRanges, employeeCardId }) => {
  return (
    <Grid wrap="nowrap" container direction="column" className={classes.root}>
      {dateRanges.map((override, index) => (
        <CalendarOverride
          key={index}
          item={override}
          count={dateRanges.size}
          employeeCardId={employeeCardId}
        />
      ))}
    </Grid>
  );
};

const styles = () => ({
  root: {
    top: 1,
    left: 1,
    right: 1,
    height: "50%",
    position: "absolute",
    width: "calc(100% - 2px)",
  },
});

export default compose(
  withStyles(styles),
  React.memo,
)(AvailabilityOverrides);
